<script lang="ts">
  import { page } from '$app/stores';

  import { roastQueue } from '$lib/PersistedState.svelte';
  import { Badge } from '$lib/components/ui/badge/index.js';

  let selectedPage = $state('/');

  const selectedClasses = 'font-bold underline';

  page.subscribe((pageData) => {
    selectedPage = pageData.url.pathname;
  });
</script>

<a
  href="/"
  data-sveltekit-preload-code="off"
  class="text-md px-3 py-2 hover:text-cool-gray-200
        {selectedPage == '/' ? selectedClasses : 'font-medium'}"
>
  Roasting
</a>
<a
  href="/queue"
  class="text-md px-3 py-2 hover:text-cool-gray-300
        {selectedPage == '/queue' ? selectedClasses : 'font-medium'}"
>
  Roast Queue
  {#if selectedPage != '/queue'}
    {#if roastQueue.unroastedLength > 0}
      <Badge>{roastQueue.unroastedLength}</Badge>
    {/if}
  {/if}
</a>
